import * as React from 'react';
import { SecondaryReportDataService, SurveyVersionDataService, Auth } from '../../services';
import { SurveyVersion, SecondaryReport } from '../../models';
import { NavLink } from 'react-router-dom';
import { ListingState, BaseRouteProps } from '../../interfaces';
import { DataGrid, PVAPage } from '../../components';
import { UserStore } from '../../stores';
import { Roles } from '../../stores/Constants';
import { computed } from 'mobx';
import { observer, inject } from 'mobx-react';

interface SecondaryReportListingProps extends BaseRouteProps<{ id: number }> {
    UserStore?: UserStore;
    Auth?: Auth;
}

interface SecondaryReportListingState extends ListingState<SecondaryReport> {
    surveyIsPublished: boolean;
}

@inject('UserStore', 'Auth') @observer
export class SecondaryReportListing extends React.Component<SecondaryReportListingProps, SecondaryReportListingState> {
    private secondaryReportDataService = new SecondaryReportDataService(this.props.notificationService);
    private surveyVersionDataService = new SurveyVersionDataService(this.props.notificationService);

    @computed get isSuperAdmin() {
        return this.props.Auth!.userRoleIn([Roles.SuperAdmin]);
    }

    constructor(props: SecondaryReportListingProps) {
        super(props);

        this.state = {
            entities: new Array<SecondaryReport>(),
            surveyIsPublished: true
        };
    }

    public componentDidMount() {
        this.surveyVersionDataService.get(this.props.match.params.id).then((surveyVersion: SurveyVersion) => {
            this.setState({
                surveyIsPublished: surveyVersion.published !== null ? true : false
            });

            this.secondaryReportDataService.getAllBySurveyVersion(surveyVersion).then((reports: SecondaryReport[]) => {
                this.setState({
                    entities: reports
                });
            });
        });
    }

    public render() {
        const listData = this.state.entities.map(entity => {
            return {
                'Name': entity.name,
                'ActionKey': entity.id
            };
        });

        const actionsColumn = ({ value }: any) => {
            return (
                <NavLink className="btn btn-default btn-block" to={`/secondaryreport/${value}`}>View</NavLink>
            );
        };

        const columnDefs = [
            { id: 'Name' },
            { id: 'ActionKey', title: 'Actions', width: '88px', customComponent: actionsColumn, sortable: false }
        ];

        return (
            <PVAPage>
                <PVAPage.Header>
                    <PVAPage.Header.Buttons>
                        <NavLink to={'/surveyversion/' + this.props.match.params.id}>
                            <span className="glyphicon glyphicon-arrow-left" />
                        </NavLink>
                        {this.isSuperAdmin &&
                            <NavLink to={'/surveyversion/' + this.props.match.params.id + '/secondaryreports/create'}>
                                <span className="glyphicon glyphicon-plus" />
                            </NavLink>
                        }
                    </PVAPage.Header.Buttons>
                    <div className="title">Secondary Reports</div>
                </PVAPage.Header>

                <PVAPage.Body>
                    <DataGrid entities={listData} columns={columnDefs} />
                </PVAPage.Body>

                <PVAPage.Footer />
            </PVAPage>);
    }
}



// WEBPACK FOOTER //
// ./src/components/secondaryreport/SecondaryReportListing.tsx